import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';;
import { Router } from '@angular/router';
import { ContractCgvStatus } from '@core/models/contract-cgv-status.model';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContractCgvStatusService extends BaseService {
  private contractCgvStatusRoute = '/cgv-status';

  constructor(
    private httpService: HttpClient,
    private snackBar: MatSnackBar,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {
    super();
  }

  public getList(filter): Observable<any> {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de récuperer la liste statut CGV. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + this.contractCgvStatusRoute + '?' + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService
        .get(url)
        .pipe(
          map(response => {
            let result = [];

            if (response['data']) {
              let contractCgvStatusList: ContractCgvStatus[] = [];

              response['data'].map(cgvStatus => {
                contractCgvStatusList.push(new ContractCgvStatus(cgvStatus));
              });

              return contractCgvStatusList;
            }

            return result;
          })
        )
        .subscribe(
          (response: any) => observer.next(response),
          error => {
            this.errorHandlerService.showErrorMessage(httpErrors, error.status);
            observer.error(error);
          }
        );
    });
  }
}
